// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__KcwGo","location":"Header_location__3tUw5"};